<template>
    <div class="flex justify-center items-center w-full h-screen">
        <div v-if="!isError" class="flex flex-wrap justify-center">
            <span class="mb-3 inline-block loader"> <img src="@/assets/images/ondemand/loader.svg" /></span>
            <p class="w-full"> Please wait, Verifying account ....</p>
        </div>
        <div v-if="isError" class="flex flex-wrap justify-center">
            <p class="w-full text-base text-red-400">Opps, Error Occured</p>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            isError: false
        }
    },
    mounted() {
        if (this.$route.query.code) {
            this.verifyUser()
        }
    },
    methods: {
        async verifyUser() {
            localStorage.setItem('token', this.$route.query.token)
            
            try {
                let payload = {
                    userId: localStorage.getItem('userId'),
                    code: this.$route.query.code
                }
                let response = await this.$_validateSignupAuthenticationToken(payload)
                if (response.data.success) {
                    this.$router.push({ name: 'SignupAuthentication', query: { auth: true, code: this.$route.query.code } });
                }
            } catch (error) {
                this.isError = true
            }
        }
    },
}
</script>

<style scoped>
.loader {
    display: inline-block;
    width: auto;
    height: auto;
    animation: 2s infinite linear rolls;
}

@keyframes rolls {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>